import React, { useState, useEffect } from 'react';
import { api } from '../../api';
import { Save, Check } from 'lucide-react';

const DAY_NAMES = ['Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi','Dimanche'];
const SAVED_FEEDBACK_MS = 2500;

const HoursAdmin = ({ content, refresh }) => {
  const [hours, setHours] = useState([]);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    const src = content.hours || [];
    const full = Array.from({ length: 7 }, (_, i) => src.find((h) => h.day === i) || { day: i, openFr: '', openEn: '', closed: false });
    setHours(full);
  }, [content]);

  const upd = (i, k, v) => setHours((arr) => arr.map((h, j) => j === i ? { ...h, [k]: v } : h));

  const save = async () => {
    setSaving(true);
    try {
      await api.put('/admin/hours', { hours });
      await refresh();
      setSaved(true);
      setTimeout(() => setSaved(false), SAVED_FEEDBACK_MS);
    } finally { setSaving(false); }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="h-display text-[32px]">Horaires d’ouverture</h2>
          <p className="text-[13px] text-[#8A8275] mt-1">Modifiez les horaires affichés sur la page contact.</p>
        </div>
        <button onClick={save} disabled={saving} className="btn-primary">
          {saved ? <><Check size={14} /> Enregistré</> : <><Save size={14} /> Enregistrer</>}
        </button>
      </div>

      <div className="space-y-3">
        {hours.map((h, i) => (
          <div key={`day-${h.day ?? i}`} className="grid md:grid-cols-12 gap-3 items-center bg-[#FAF8F4] border border-[#E8E2D5] p-4">
            <div className="md:col-span-2 font-medium text-[14px]">{DAY_NAMES[i]}</div>
            <div className="md:col-span-2 flex items-center gap-2">
              <input type="checkbox" checked={h.closed} onChange={(e) => upd(i, 'closed', e.target.checked)} id={`c${i}`} className="w-4 h-4 accent-[#957340]" />
              <label htmlFor={`c${i}`} className="text-[12px] tracking-wide text-[#3A3A3A]">Fermé</label>
            </div>
            <input value={h.openFr} disabled={h.closed} onChange={(e) => upd(i, 'openFr', e.target.value)} placeholder="FR ex: 10h00 – 20h00"
              className="md:col-span-4 bg-white border border-[#E8E2D5] focus:border-[#957340] outline-none p-2 text-[13px] disabled:opacity-40" />
            <input value={h.openEn} disabled={h.closed} onChange={(e) => upd(i, 'openEn', e.target.value)} placeholder="EN ex: 10 AM – 8 PM"
              className="md:col-span-4 bg-white border border-[#E8E2D5] focus:border-[#957340] outline-none p-2 text-[13px] disabled:opacity-40" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default HoursAdmin;
